// Central test IDs for landing page interactions
export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkServices: "nav-link-services",
  linkResults: "nav-link-results",
  linkProcess: "nav-link-process",
  linkPackages: "nav-link-packages",
  linkAudit: "nav-link-audit",
  linkContact: "nav-link-contact",
  cta: "nav-cta-book-audit",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  headline: "hero-headline",
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
};

export const LEAD_FORM = {
  section: "lead-form-section",
  name: "lead-input-name",
  business: "lead-input-business",
  website: "lead-input-website",
  email: "lead-input-email",
  phone: "lead-input-phone",
  budget: "lead-input-budget",
  budgetOption: (v) => `lead-budget-option-${v}`,
  challenge: "lead-input-challenge",
  submit: "lead-submit",
  success: "lead-success-message",
  error: "lead-error-message",
};

export const FAQ = {
  section: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const PACKAGES = {
  starterCta: "package-cta-starter",
  performanceCta: "package-cta-performance",
  aiCta: "package-cta-ai",
};

export const CTA = {
  final: "final-cta-book",
  auditSectionCta: "audit-section-cta",
};

export const HOME = {
  emergentLink: "emergent-link",
};
